<app-loader *ngIf="isDisabled"></app-loader>
<form name="SiteHolidayForm" (ngSubmit)="SiteHolidayForm.form.valid && SaveSiteHoliday()" #SiteHolidayForm="ngForm">
    <div class="pt-1">
        <div class="card">
            <div class="card-header">
                <div class="card-title">Site Holiday Mapping</div>
            </div>

            <div class="card-body">
                <form name="SiteHolidayFilterForm" (ngSubmit)="Validate(SiteHolidayFilterForm)"
                    #SiteHolidayFilterForm="ngForm">
                    <div class="row py-1 pb-2">
                        <div class="col-md-2">
                            <label>Year</label>
                            <select name="Year" class="form-select" [(ngModel)]="filter.Year" #Year="ngModel"
                                (ngModelChange)="ClearHolidays()" required [disabled]="DisablesFilter.Year">
                                <option [value]=null disabled hidden>Select Year</option>
                                <option *ngFor="let Year of Years" [value]="Year">
                                    {{Year}}
                                </option>
                            </select>
                            <div class="invalid-feedback">
                                Please select year.
                            </div>

                        </div>
                        <div class="col-md-2">
                            <label>State</label>
                            <ng-select name="State" (change)="ComboLoad('ClientLoadOnStateId');ClearSiteClient();"
                                [(ngModel)]="filter.StateId" placeholder="Select State" required
                                [disabled]="this.filter.Year  == null">
                                <ng-option *ngFor="let State of StatesFilter"
                                    [value]="State.StateMasterID">{{State.StateName}}</ng-option>
                            </ng-select>

                            <div class="invalid-feedback">
                                Please select state.
                            </div>

                        </div>
                        <div class="col-md-3">

                            <label>Client</label>
                            <ng-select name="Client" (change)="ComboLoad('ClientWiseSite');ClearSite();"
                                [(ngModel)]="filter.ClientId" placeholder="Select Client" required
                                [disabled]="this.filter.Year  == null">
                                <ng-option *ngFor="let Client of ClientsFilter"
                                    [value]="Client.ClientGroupMasterID">{{Client.ClientGroupName}}</ng-option>
                            </ng-select>

                            <div class="invalid-feedback">
                                Please select client.
                            </div>

                        </div>
                        <div class="col-md-3">

                            <label>Site</label>
                            <ng-select [items]="SitesFilter" [multiple]="true" bindLabel="SiteName" name="muliex"
                                [selectableGroup]="false" [selectableGroupAsModel]="false" [closeOnSelect]="false"
                                bindValue="SiteMasterID" [(ngModel)]="filter.SiteIdObj" placeholder="Select Site"
                                required [disabled]="this.filter.Year  == null" (click)="CheckDiselect()">

                                <ng-template ng-header-tmp let-items="items">
                                    <input type="checkbox" (change)="CheckAll($event,'Site')" /> Check All
                                </ng-template>

                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <input id="item-{{index}}" name="item-{{index}}" type="checkbox"
                                        [ngModel]="item$.selected"
                                        [disabled]="common.ToLowerCase(item.IsClientMapped) === 'mapped'"
                                        [disabled]="common.ToLowerCase(item.IsClientMapped) == 'mapped' && item.ESS_SiteOnClientHolidayMasterId != this.filter.ESS_SiteOnClientHolidayMasterID"
                                        [ngModelOptions]="{ standalone : true }" />
                                    {{item.SiteName}}
                                </ng-template>
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                        <span class="ng-value-label">{{item.SiteName}}</span>
                                    </div>
                                    <div class="ng-value" *ngIf="items.length > 1">
                                        <span class="ng-value-label">{{items.length - 1}} +...</span>
                                    </div>
                                </ng-template>
                            </ng-select>

                            <div class="invalid-feedback">
                                Please select site.
                            </div>

                        </div>
                        <div class="col-md-auto pt-4">
                            <button type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Get Holiday':'Loading...'}}</button>
                        </div>
                    </div>
                </form>
                <div class="row">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th>Holiday Name</th>
                                <th style="width: 150px">Date</th>
                                <th style="width: 250px;">Not Applicable/Compulsory/Optional</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let element of SiteHolidayData;let i=index">
                                <td>{{element.HolidayName}}</td>
                                <td style="width: 150px">{{element.Date}}</td>
                                <td style="width: 250px;">
                                    <select name="TypesOfLeave{{i+1}}" placeholder="Select types of leave"
                                        [(ngModel)]="element.TypesOfLeave" #TypesOfLeave="ngModel">
                                        <option *ngFor="let TypesOfLeave of TypesOfLeaves" [value]="TypesOfLeave">
                                            {{TypesOfLeave}}
                                        </option>
                                    </select>
                                </td>

                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
            <div class="card-footer">
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                        (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Cancel':'Loading...'}}</button>

                    <button type="submit" class="btn btn-primary text-nowrap" [disabled]="isDisabled"><i
                            class="bi bi-save" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>